import { render, staticRenderFns } from "./TeacherTitlings.vue?vue&type=template&id=168167fb"
import script from "./TeacherTitlings.vue?vue&type=script&lang=js"
export * from "./TeacherTitlings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('168167fb')) {
      api.createRecord('168167fb', component.options)
    } else {
      api.reload('168167fb', component.options)
    }
    module.hot.accept("./TeacherTitlings.vue?vue&type=template&id=168167fb", function () {
      api.rerender('168167fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/chart/TeacherTitlings.vue"
export default component.exports